import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "31",
  fill: "none",
  viewBox: "0 0 25 31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "M23.5 10.543h-22a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1Z"
      }),
      _createElementVNode("path", {
        "stroke-miterlimit": "10",
        d: "M12.5 19.543a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12.5 19.543v4"
      }),
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "M19.5 7.543v3M5.5 10.543v-3M5.5 7.543c0-3.865 3.135-7 7-7s7 3.135 7 7"
      })
    ], -1)
  ])))
}
export default { render: render }